/**
 * Created by Mark on 18/04/2017.
 */

import React  from 'react';
import Card from '../card.js';
import CardHeader from '../card-header.js';
import CardBody   from '../card-body.js';
import ProgressBar from './progress-component.js';
import Step from './wizard-step.js';

const  clone = function (obj) {
    if (null == obj || "object" != typeof obj) return obj;
    var copy = obj.constructor();
    for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
    }
    return copy;

}

export default class Wizard extends React.Component {

    constructor(props){
        super();
        this.props = props;
        this.state ={currentStep:0, data:this.props.data ? clone(this.props.data) : {}}
        this.modifiyWizard = this.props.onModify || function() {};
    }

    componentWillReceiveProps(props){

        this.props = props;
        this.setState({update:true});

      /*  var newProps = props.data ? clone(props.data) : {};
        var oldProps = clone(this.state.data) || {};

        console.log(props);
        for(var key in newProps){
            if(newProps.hasOwnProperty(key)) oldProps[key] = newProps[key];
        }

        console.log(oldProps);

        this.setState({data:clone(oldProps)});*/
    }


    render(){

        const self = this;
        const step =  this.props.steps[this.state.currentStep];
        const items = this.props.steps.map((item, i) => (
            <li data-step={i+1} key={"wizard-step-"+i} className={ (this.state.currentStep === i ? 'is-active' : this.state.currentStep > i ? 'is-active' : '') }>
                { item.name }
            </li>
        ));


        console.log(this.state);
        const Component = React.createElement(Step, {
            key: 'step' + this.state.currentStep,
            onSubmit: step.onSubmit,
            disableButtons:step.disableButtons,
            onModify:this.modifiyWizard,
            onBack: step.onBack,
            onAdvance: function(){
                self.setState({
                    currentError: null,
                    currentStep: self.state.currentStep+1
                });
            },
            onRetreat: function(){
                self.setState({
                    currentError: null,
                    currentStep: self.state.currentStep-1
                });
            },
            handelError: step.handelError || false,
            component: step.component,
            data: this.state.data,
            navigationTop:step.navigationTop,
            firstStep: this.state.currentStep === 0,
            lastStep:  this.state.currentStep === this.props.steps.length-1
        });
        const  title = step.title ? <h2 className="m-t-20">{step.title}<small className="float-right">{step.description}</small></h2> : null;
        return <Card>
                    <CardHeader>
                        <ol className={this.props.stepsNavigation ? "wizard-progress" : "hide" }>{items}</ol>
                        <ProgressBar now={((this.state.currentStep+1)/this.props.steps.length)*100 } />
                        {title}
                    </CardHeader>
                    <CardBody >
                        {Component}
                    </CardBody>
                </Card>
    }

}




// WEBPACK FOOTER //
// ./src/components/wizard/wizard.js